import { render, staticRenderFns } from "./MobileCommunitySubMenu.vue?vue&type=template&id=58c513be&"
import script from "./MobileCommunitySubMenu.vue?vue&type=script&lang=ts&"
export * from "./MobileCommunitySubMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports